/**
 * OpenList 工具函数导出索引
 */

export * from "../openlist-tree-utils"
export * from "../openlist-file-utils"

export function getPlatformName(platform: string): string {
  const names = {
    baidu: "百度网盘",
    aliyun: "阿里云盘",
    quark: "夸克网盘",
    "115": "115网盘",
    "123": "123网盘",
  }
  return names[platform as keyof typeof names] || platform
}
